__turbopack_context__.v({
  "fullScreenButton": "_2p5LQq_fullScreenButton",
  "placeholder": "_2p5LQq_placeholder",
  "sliderOverlayContainer": "_2p5LQq_sliderOverlayContainer",
  "zoomButton": "_2p5LQq_zoomButton",
  "zoomButtonContainer": "_2p5LQq_zoomButtonContainer",
});
